import * as React from 'react';
import BrandSubscriptionListView from './BrandSubscriptionListView';
import BrandSubscriptionServiceCallState from '../store/schema/BrandSubscriptionServiceCallState';
import getStore from '../store/store';
import strings from 'owa-strings/owa-options-strings';
import { getIsLightBaseTheme } from 'owa-theme';
import { loadBrandsSubscriptions } from '../actions/internalActions';
import { observer } from 'mobx-react';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';

const styles = require('./BrandsSubscriptionsFull.scss');

@observer
export default class BrandsSubscriptionsFull extends React.Component<{}, {}> {
    componentDidMount() {
        const store = getStore();
        if (
            store.serviceCallState === BrandSubscriptionServiceCallState.NotCalled ||
            store.serviceCallState === BrandSubscriptionServiceCallState.Failed
        ) {
            loadBrandsSubscriptions();
        }
    }

    render() {
        const store = getStore();
        if (store.serviceCallState === BrandSubscriptionServiceCallState.NotCalled) {
            return null;
        }

        if (store.serviceCallState === BrandSubscriptionServiceCallState.InProgress) {
            return <Spinner className={styles.centralizedMessage} />;
        }

        if (store.serviceCallState === BrandSubscriptionServiceCallState.Failed) {
            let LOADING_ERROR__SVG;
            if (getIsLightBaseTheme()) {
                // colored svgs that goes with the blue base theme
                LOADING_ERROR__SVG = require('../svg/colored/loadingError.svg');
            } else {
                // gray scale svgs
                LOADING_ERROR__SVG = require('../svg/gray/loadingError.svg');
            }

            return (
                <div className={styles.centralizedMessage}>
                    <img src={LOADING_ERROR__SVG} width="120px" height="120px" />
                    <div className={styles.mainMessageText}>
                        {strings.options_subscriptions_loadsubscriptions_failed}
                    </div>
                </div>
            );
        }

        return (
            <>
                <div className={store.unsubscribedSubscriptions.length > 0 && styles.section}>
                    <div className={styles.header}>
                        {this.getSubscriptionMessage(store.subscriptions.length)}
                    </div>
                    <div className={styles.content}>
                        <BrandSubscriptionListView
                            brandsSubscriptions={store.subscriptions}
                            isUnsubscribed={false}
                        />
                    </div>
                </div>
                {store.unsubscribedSubscriptions.length > 0 && (
                    <>
                        <div className={styles.header}>
                            {strings.options_unsubscribed_list_header}
                        </div>
                        <div className={styles.content}>
                            <BrandSubscriptionListView
                                brandsSubscriptions={store.unsubscribedSubscriptions}
                                isUnsubscribed={true}
                            />
                        </div>
                    </>
                )}
            </>
        );
    }

    private getSubscriptionMessage(length: number): string {
        return length === 0
            ? strings.options_no_subscriptions_title
            : strings.options_subscribed_list_header;
    }
}
